<template>
  <v-app>
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="4">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-subheader>دسته بندی</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-select
            :items="items"
            v-model="selectItem"
            label="دسته بندی"
            reverse
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-subheader>توضیح</v-subheader>
        </v-col>
        <v-col cols="8">
          <ckeditor
            v-model="description"
            placeholder="توضیح"
            :config="editorConfig"
          ></ckeditor>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="ml-4" @click="editHandler"> ثبت کردن </v-btn>
        <v-btn> پاک کردن </v-btn>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  created() {
    axios
      .get(`http://api.karaclub.com/api/GuideCategory/GetAll`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        response.data.data.map((item) => {
          this.listCategory.push(item);
          this.items.push(item.title);
        });
      });
    axios
      .get(
        `http://api.karaclub.com/api/Guide/GetById?id=${this.$route.params.id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        this.title = response.data.data.title;
        this.description = response.data.data.image;
      });
  },
  data() {
    return {
      id: this.$route.params.id,
      title: "",
      description: "",
      items: [],
      editorConfig: {
        versionCheck: false,
      },
      listCategory: [],
      selectItem: null,
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    async editHandler() {
      this.listCategory.map((item) => {
        if (item.title == this.selectItem) {
          this.selectItem = item.id;
        }
      });
      await axios
        .put(
          "http://api.karaclub.com/api/Guide/Edit",
          {
            id: this.id,
            title: this.title,
            categoryId: this.selectItem,
            description: this.description,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/static-management/guide");
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>
